import { getLocationLabel, useLocationItems } from "./locationLookup";

export { getLocationLabel };

/**
 * Resolves location ids to display names. Ids that are still loading or that
 * failed are absent from the result, so callers should fall back to the raw id.
 */
export function useLocationNames(ids: string[]): Record<string, string> {
  const { items } = useLocationItems(ids);

  const names: Record<string, string> = {};
  ids.forEach((id) => {
    const item = items[String(id)];
    if (item) names[String(id)] = getLocationLabel(item);
  });
  return names;
}

export function useLocationName(id: string): string | undefined {
  return useLocationNames([id])[String(id)];
}
